import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';

const AltAllocationMessageContext = React.createContext(undefined);

export const AltAllocationMessageProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [collection, setCollection] = useState(undefined);
  const { displayErrorMessage } = useSnackbarContext();

  const fetchMessage = useCallback(async (rel) => {
    setLoading(true);
    try {
      const resp = await rel.link('related').get();
      setCollection(resp);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setLoading(false);
    }
  }, []);

  const memoizedValue = React.useMemo(() => {
    return {
      collection,
      fetchMessage,
      loading,
    };
  }, [
    collection,
    fetchMessage,
    loading,
  ]);

  return (
    <AltAllocationMessageContext.Provider value={memoizedValue}>
      {children}
    </AltAllocationMessageContext.Provider>
  );
};

AltAllocationMessageProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export const useAltAllocationMessageContext = () => {
  const context = React.useContext(AltAllocationMessageContext);

  if (context === undefined) {
    throw new Error('AltAllocationMessageContext must be used within a AltAllocationMessageProvider');
  }

  return context;
};
